module.exports = __webpack_public_path__ + "images/mobile/img-empty-topics-eb4cdaa9650b55277edbd9ee2f883867.png";